<template>
  <div class="letter_wrap set-page">
    <div class="red_top_bg page-top">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('user.setting') }}
      </div>
    </div>

    <div class="settings-card">
      <van-cell
        class="settings-cell"
        is-link
        @click="$router.push('/language')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="list-switching"
              size="22"
            />
            <span class="custom-title">{{ $t('safe.language') }}</span>
          </span>
        </template>
      </van-cell>
      <van-cell
        class="settings-cell"
        is-link
        @click="$router.push('/setpwd')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="lock"
              size="22"
            />
            <span class="custom-title">{{ $t('safe.signInPassword') }}</span>
          </span>
        </template>
      </van-cell>
      <van-cell
        class="settings-cell"
        is-link
        @click="$router.push('/setpaypwd')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="shield-o"
              size="22"
            />
            <span class="custom-title">{{ $t('safe.paymentPassword') }}</span>
          </span>
        </template>
      </van-cell>
      <van-cell class="settings-cell">
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="brush-o"
              size="22"
            />
            <span class="custom-title">{{ $t('feng.cache') }}</span>
          </span>
        </template>
      </van-cell>
      <van-cell
        class="settings-cell"
        value=" V1.0.0 "
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="info-o"
              size="22"
            />
            <span class="custom-title">{{ $t('feng.version') }}</span>
          </span>
        </template>
      </van-cell>
    </div>

    <div class="logout-wrap">
      <button
        type="button"
        class="history_coupon"
        @click="logout"
      >
        <span>{{ $t('safe.signOut') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import Fetch from '../../utils/fetch';

export default {
  name: "Set",
  data() {
    return {
      title: "title_" + (this.$i18n.locale || "zh_cn"),
      content: "content_" + (this.$i18n.locale || "zh_cn"),
      app: null,
      data: {},
    };
  },
  created() {
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/index/webconfig').then((r) => {
        this.app = r.data;
      });
    },
    logout() {
      localStorage.removeItem('token');
      this.$router.replace("/");
    }
  }
};
</script>

<style lang="less" scoped>
.set-page {
  min-height: 100vh;
  padding-bottom: 96px;
  background: #111;
  color: #f6f6f6;
  box-sizing: border-box;
}

button {
  border: 0;
  font: inherit;
  cursor: pointer;
}

.page-top {
  position: relative;
  top: 0;
  left: 50%;
  z-index: 10;
  transform: translateX(-50%);
  background: #111;
  color: #f6f6f6;
  border-bottom: 1px solid #242424;
  box-sizing: border-box;

  .back_left {
    filter: invert(1);
    opacity: 0.88;
  }

  .big_tit {
    max-width: 72%;
    color: #f6f6f6;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: normal;
  }
}

.settings-card {
  margin: 14px 16px 0;
  padding: 4px 14px;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid #303030;
  background: #222;
  box-shadow: 0 12px 22px rgba(0, 0, 0, 0.22);
  box-sizing: border-box;
}

/deep/ .van-cell {
  min-height: 54px;
  padding: 0;
  display: flex;
  align-items: center;
  background: transparent;
  color: #f6f6f6;
  line-height: 54px;
}

/deep/ .van-cell:not(:last-child) {
  border-bottom: 1px solid #303030;
}

/deep/ .van-cell::after {
  display: none;
}

/deep/ .van-cell__title {
  min-width: 0;
}

/deep/ .van-cell__value {
  color: #9aa1aa;
  font-size: 14px;
}

/deep/ .van-cell__right-icon {
  color: #9aa1aa;
  font-size: 16px;
  line-height: 54px;
}

.menu-title {
  min-width: 0;
  display: flex;
  align-items: center;
}

.menu-icon {
  flex: 0 0 auto;
  margin-right: 10px;
  color: #8ea0ff;
}

.custom-title {
  overflow: hidden;
  color: #f6f6f6;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.logout-wrap {
  margin: 18px 16px 0;
}

.history_coupon {
  width: 100%;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid #343434;
  background: rgba(101, 123, 233, 0.18);
  color: #8ea0ff;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}


.basic_btn,
.history_coupon,
.wallet-btn.is-primary,
.allbtn {
  border: 0;
  background: linear-gradient(100deg, #657be9 0%, #8c52bd 100%) !important;
  color: #fff;
}


.page-top {
  background: #101010;
}

@media screen and (max-width: 374px) {
  .settings-card,
  .logout-wrap {
    margin-right: 12px;
    margin-left: 12px;
  }
}
</style>
